import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { DataUtil } from '../../../../_private/assets/ts/_utils';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { ChartData } from 'chart.js';
// import { Colors, Ticks } from 'chart.js/dist';
// import { bottom } from '@popperjs/core';
import { useThemeMode } from '../../../partials/layout/theme-mode/ThemeModeProvider';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

type data = {
  label: string,
  data : number[],
  backgroundColor: string[];
  borderColor: string[];
  borderWidth: number
};

type GameplaySummary = {
  labels: string[];
  datasets: data[];
};


type Props = {
  categoryData: GameplaySummary
};

const DashboardChart: React.FC<Props> = ({categoryData}) => {

  const {mode} = useThemeMode()
  let [color, setColor] = useState('#3d3d3d');
  let [gridColor, setGridColor] = useState('#e1e1e1'); 
  useEffect(()=>{
    if(mode === 'dark'){
      setColor('#fff');
      setGridColor('#444444');
    }
    else{
      setColor('#3d3d3d');
      setGridColor('#e1e1e1');
    }
  }, [mode])

  // const [graphData, setGraphData] = useState([]);
  // const [count, setCount] = useState(0);

  // function getPreviousNDates(n: number): string[] {
  //   const result: string[] = [];
  //   const currentDate = new Date();
  
  //   // Helper function to format the date as 'DD/MM' without using padStart
  //   function formatDate(date: Date): string {
  //     const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate().toString();
  //     const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1).toString();
  //     return `${day}/${month}`;
  //   }
  
  //   // Iterate over the last `n` days, including today
  //   for (let i = 0; i < n; i++) {
  //     result.push(formatDate(currentDate));
  //     currentDate.setDate(currentDate.getDate() - 1); // Go to the previous day
  //   }
  
  //   // Reverse the array so it starts from the oldest date
  //   return result.reverse();
  // }


  // Define the types for your chart data
  const data: ChartData<'bar', number[], string> = categoryData;

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: "Top Categories This Month",
        position: 'bottom',
        align: 'center',
        color: color
      },
    },
    color: color,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value, index, ticks) {
              return DataUtil.formatNumber(value);
          },
          color: color,
        },
        grid: {
          color: gridColor
        }
      },
      x: {
        ticks: {
          color: color,
        },
        grid: {
          color: gridColor
        }
      }
    }
  };
  
  return <Bar data={data} options={options} />;
};

export default DashboardChart;